import React, { useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";
import { adminApiService } from "services/api";

const FooterSeoSection = () => {
  const [content, setContent] = useState("");

  const handleEditorChange = (content, editor) => {
    setContent(content);
  };

  const saveContent = async () => {
    try {
      const response = await adminApiService.updateFooterSeo(content);

      if (!response.ok) {
        throw new Error("Failed to save content");
      }

      const result = await response.json();
      console.log("Content saved successfully:", result);
      toast.success("Content saved successfully!");
    } catch (error) {
      console.error("Error saving content:", error);
      toast.error("Failed to save content. Please try again.");
    }
  };

  //get seo content
  const getSeoContent = async () => {
    try {
      const response = await adminApiService.getFooterSeo();
      if (!response.ok) {
        throw new Error("Failed to get content");
      }
      const result = await response.json();
      console.log("result", result);

      setContent(result.data.content);
    } catch (error) {
      console.error("Error getting content:", error);
      toast.error("Failed to get content. Please try again.");
    }
  };

  useEffect(() => {
    getSeoContent();
  }, []);

  return (
    <div>
      <Editor
        apiKey={process.env.REACT_APP_TINY_MCE_EDITOR_API_KEY}
        value={content}
        init={{
          height: 1000,
          menubar: true,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "print",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "paste",
            "help",
            "wordcount",
            "imagetools",
            "emoticons",
            "template",
            "directionality",
            "textcolor",
            "colorpicker",
            "autosave",
            "codesample",
            "textpattern",
            "mediaembed",
            "toc",
            "autoresize",
            "charcount",
            "codesample",
            "quickbars",
            "emoji",
            "autosave",
            "dragdrop",
            "filemanager",
            "codebeamer",
            "contextmenu",
            "imagegallery",
            "spellchecker",
            "mention",
            "wordcount",
            "importcss",
            "print",
            "fullscreen",
            "pagebreak",
            "directionality",
            "visualchars",
          ],
          toolbar:
            "undo redo | formatselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | fontselect fontsizeselect | forecolor backcolor | bullist numlist outdent indent | link image media table | blockquote code | insertdatetime emoticons charmap | fullscreen preview | removeformat | help | searchreplace visualblocks | insertfile | pagebreak | insertdate inserttime | ltr rtl | copy paste cut",
          menubar: "file edit view insert format tools table help",
          quickbars_selection_toolbar:
            "bold italic | quicklink h2 h3 blockquote quickimage",
          contextmenu:
            "cut copy paste | link image | inserttable | cell row column",
          image_advtab: true,
          file_picker_types: "image,media",
          toolbar_sticky: true,
          image_caption: true,
          statusbar: true,
          branding: false,
          toolbar_mode: "sliding",
        }}
        onEditorChange={handleEditorChange}
      />

      <div className="mt-10 flex w-full justify-end">
        <button
          onClick={saveContent}
          className="text-primaryText mt-5 rounded-md bg-primary px-4 py-2 font-medium transition duration-200 hover:bg-primaryDark "
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default FooterSeoSection;
